/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo, type ReactNode } from 'react';

import { cssMap, jsx } from '@compiled/react';

import ShapesIcon from '@atlaskit/icon/core/shapes';

type Props = {
	iconUrl?: string;
	defaultIcon?: ReactNode;
};

const styles = cssMap({
	icon: {
		width: '16px',
		height: '16px',
	},
});

export const PanelIcon = memo(({ iconUrl, defaultIcon }: Props) => {
	if (iconUrl) {
		return <img src={iconUrl} alt="" css={styles.icon} />;
	}

	return defaultIcon ? defaultIcon : <ShapesIcon label="" />;
});
